// Turnstile modes
// none: No turnstile is shown
// register: The turnstile is shown for registration only
// sign-in: The turnstile is shown for sign-in and registration

export const TurnstileModeValues = ["none", "register", "sign-in"] as const
export type TurnstileModes = (typeof TurnstileModeValues)[number]
